import { useQuery } from "react-query";
import axiosInstance from "../../../../common/axiosInstance";

// Modify the hook to accept a restaurantId and adjust the query key accordingly
export const useFetchStoreStripeAccountId = (storeId: string | null | undefined ) => {
    return useQuery(['storeStripeAccountId', storeId], () => getStoreStripeAccountId(storeId), {
        enabled: !!storeId // Fetch data only if restaurantId is present
    });
};

const getStoreStripeAccountId = async (storeId: string | null | undefined) => {
    if (!storeId) {
        throw new Error("storeId is required");
    }
    const response = await axiosInstance.get(`https://api.menufy.link/restaurantBackend/stores/stripeInfo?storeId=${storeId}`);
    return response.data;
};
